export default "__VITE_ASSET__uWhL$EMt__"